import { Box } from '@hover/blueprint';
import React from 'react';

import { Skeleton } from 'src/shared/components/Skeleton/Skeleton';

const ProjectCardSkeleton = ({ numBoxes = 3 }: { numBoxes?: number }) => (
  <>
    {Array(numBoxes)
      .fill(null)
      .map((_, i) => (
        <Box
          borderColor="gray.200"
          borderRadius="350"
          borderWidth="1px"
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          minHeight="800"
          overflow="hidden"
          p="5"
          shadow="distance300"
        >
          <Skeleton height="100%" width="100%" />
        </Box>
      ))}
  </>
);

export { ProjectCardSkeleton };
